export const Colors = {
  blue50: "#eef6ff",
  blue100: "#d7e9ff",
  blue300: "#82b9ff",
  blue400: "#4f97f7",
  blue500: "#2563eb",
  blue700: "#1d4ed8",
  blue800: "#1e3a8a",
  grey100: "#f8fafc",
  grey200: "#e2e8f0",
  grey300: "#cbd5e1",
  grey400: "#94a3b8",
  grey500: "#64748b",
  grey800: "#1f2937",
  yellow100: "#ffff99",
  yellow400: "#ffff66",
  yellow500: "#ffff00",
  red400: "#f79892",
  green100: "#99ff99",
  green400: "#66ff66",
  green500: "#33cc33",
};
